"use strict";

import module from "./module";

import "./function.spec";
import "./dialog.controller.spec";

export default module;
